// src/pages/CourseTime/components/FloatingActivityButton.comp.jsx
import React from 'react';
import { FloatingActivityButton } from '../styles/activity.styles';
import { GET_APP_LOCALIZE_TEXT } from '../../../utils/dq_lc_service/lc_service';

// Activity icon SVG component
const ActivityIcon = () => (
  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
    />
  </svg>
);

const FloatingActivityButtonComponent = ({ onClick, disabled = false, activityCount = 0, pageLc }) => {
  const title = GET_APP_LOCALIZE_TEXT(pageLc, 'ct__view_activity_responses');
  return (
    <FloatingActivityButton
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={title}
    >
      <ActivityIcon />
    </FloatingActivityButton>
  );
};

export default FloatingActivityButtonComponent;
